import { create } from "zustand";

type SavedPaginationState = {
    savedPagination: Map<string, number>
    setPagePagination: (path: string, pagination: number) => void;
}

export const useSavedPaginations = create<SavedPaginationState>(
        (set) => ({
            savedPagination: new Map(),
            setPagePagination: (path, pagination) => {
                set(state => {
                    state.savedPagination.set(path, pagination);
                    return { savedPagination: new Map(state.savedPagination) }
                })
            }
        })
)
